// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-13ZCZ";
var _4 = "delimiter-aqFYh";
var _5 = "price-1_I6e";
var _6 = "clear-20w_q";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "delimiter", _5 as "price", _6 as "clear" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "delimiter": _4, "price": _5, "clear": _6 }
